import { PropsWithChildren, ReactElement } from 'react';
import { TableBody, styled } from '@mui/material';

const StyledTableBody = styled(TableBody)(({ theme }) => ({
    '&& .MuiTableCell-body': {
        ...theme.typography.body1,
        color: theme.palette.text.primary,
        height: 56,
        padding: theme.spacing(2),
    },
}));

export const SupplierTableBody = (props: PropsWithChildren): ReactElement => {
    const { children, ...tableHeadProps } = props;
    return <StyledTableBody {...tableHeadProps}>{children}</StyledTableBody>;
};
